<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../mixins/userRole'
export default {
  name: 'GautasPranesimas',
  props: {
    ntrpaslaugos: { type: Boolean, default: false },
    isRedirect: { type: Boolean, default: false },
  },
  mixins: [userRole],
  computed: {
    ...mapGetters(['appSavitarna']),
    isSavitarna() {
      return this.appSavitarna
    },
    pranesimasUrl() {
      return this.$route.params.pranesimas
    },
    pranesimasNumeris() {
      if (!(this.pranesimasUrl && this.pranesimasUrl.length > 0)) {
        return null
      }
      return this.pranesimasUrl.replaceAll('-', '/')
    },
  },
  created() {
    this.pranesimasRedirect()
  },
  methods: {
    pranesimasRedirect() {
      sessionStorage.setItem('gautasPranesimas', this.pranesimasNumeris)

      if (this.isRedirect) {
        const fullPath = this.$route.fullPath
        const newPath = fullPath.replace(
          '/gautas-ntr-pranesimas',
          'ntr-paslaugos/gautas-pranesimas'
        )
        window.location.href = `${process.env.VUE_APP_SAVITARNA_URL}${newPath}`
        return
      }

      const ipasasUrl = process.env.VUE_APP_IPASAS_URL

      if (this.isSavitarna) {
        const ipasasRedirect = `${ipasasUrl.replace(
          'TURTAS',
          'savitarna'
        )}&menu_id=${this.ntrpaslaugos ? '150' : '351'}`
        window.location.href = ipasasRedirect
        return
      }

      window.location.href = ipasasUrl
    },
  },
}
</script>
